import React, { useState } from 'react';
import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import { initialClientsEventBooking } from './components/appointments/initialClientsEventBooking';
import ClientsEventBookingContext from './components/appointments/hooks/ClientsEventBookingContext';
import BookingLayout from './components/ui/BookingLayout';
import AppointmentBooking from './components/appointments/AppointmentBooking';
import '../booking.scss';
import '../../../base/stylesheets/_calendars.scss';
import CurrentClientWrapper from './components/ui/CurrentClientWrapper';
import AppointmentForm from './components/appointments/AppointmentForm';
import RefetchWrapper from '../../../base/ui/refetch/RefetchWrapper';
import BackdropWrapper from '../../../base/ui/backdrop/BackdropWrapper';
import useNotificationState from '../../../base/hooks/useNotificationState';
import NotificationStateContext from '../../../wedding-wardrobe/src/components/base/NotificationStateContext';
import Notification from '../../../wedding-wardrobe/src/components/base/Notification';
import VirtualAppointments from "./components/virtual-appointments/VirtualAppointments";

export default () => {
  const [proceedTo, setProceedTo] = useState('');
  const [clientsEventBooking, setClientsEventBooking] = useState(initialClientsEventBooking);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showMenuItems, setShowMenuItems] = useState(false);

  const { Switch, Route, useHistory } = useAppContext();
  const { MuiPickersUtilsProvider, DateFnsUtils } = useUiContext();

  const bookingContext = {
    clientsEventBooking,
    setClientsEventBooking,
    mobileMenuOpen,
    setMobileMenuOpen,
    showMenuItems,
    setShowMenuItems,
    proceedTo,
    setProceedTo,
  };
  const notificationState = useNotificationState();

  const { notificationState: { message, severity, opened } } = notificationState;

  const history = useHistory()
  history.listen((location, action) => {
    window.scrollTo(0, 0)
  });

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <NotificationStateContext.Provider value={notificationState}>
        <Notification message={message} severity={severity} opened={opened} />
        <Switch>
          <BackdropWrapper>
            <RefetchWrapper>
              <CurrentClientWrapper>
                <ClientsEventBookingContext.Provider value={{ ...bookingContext }}>
                  <BookingLayout>
                    <Route path={`${process.env.PROXY_PATH}/booking/onboarding`} exact>
                      <AppointmentForm />
                    </Route>
                    <Route path={`${process.env.PROXY_PATH}/booking/appointment/:gid`}>
                      <AppointmentBooking />
                    </Route>
                    <Route path={`${process.env.PROXY_PATH}/booking/virtual-appointment`}>
                      <VirtualAppointments />
                    </Route>
                  </BookingLayout>
                </ClientsEventBookingContext.Provider>
              </CurrentClientWrapper>
            </RefetchWrapper>
          </BackdropWrapper>
        </Switch>
      </NotificationStateContext.Provider>
    </MuiPickersUtilsProvider>
  );
};
